import { DatapointAggregate, DoubleDatapoint } from '@cognite/sdk';
export function hasRawPoints(
  datapoints: DatapointAggregate[] | DoubleDatapoint[] = []
) {
  return datapoints.some((point) => 'value' in point) || false;
}
